import { DataGrid } from "@mui/x-data-grid";
import {
  fKeyTabInput,
  hasValueInErrorMessage,
} from "../../../Utility/Utilitys";
import {
  CmpDatePickerField,
  CmpSelectField,
  CmpSelectArrField,
  CmpInputField,
  CmpCheckboxField,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";

import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import Grid from "@mui/material/Grid";
import { CmpDatePickerField001V1, CmpSelectArrFieldV1, CmpSelectFieldV1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";

// import Modal from "@mui/material/Modal";
// import Box from '@mui/material/Box';

export default function GCHead({
  fOpenERPStockModal,
  xItemStock,
  vRdxSalesOrderHead,
  sLocation,
  DocLoading,
  currency,
  selecType,
  fOpenHeadCustomerSearchModalKey,
  sPayModeArr,
  fOnChangeSelectDocType,
  fOnChangeSelectCurr,
  fOnChangeInputDate,
  fOnChangeInputDateRefDate,
  fonChangeInput,
  fonChangeInputTaxType,
  fonChangeInputPayMode,
  fonChangeInputTaxable,

  fonChangeInputIsStockReserved,
  fonChangeInputLocation,
  fonChangeInputCustomer,
  sErrorMsg,
  sDetailGridData,
  sToggleGrid,
  GridDataSalesHistoryColumns,
  sGridSalesHistoryRowData,
  vMediaQuery,

  xcolumnsDropdownSearch,
  xrowDropdownSearch,
  xOnCellKeyDown,
  xOnRowClick,
  xToggleDropdown,
  xhandleClick,
  inputReference,
  xData,
  xOnChange,
  xDropdownObj,
  xOnKeyUp,
  xPaymodeEnable,
  xOsAmount = "",
  sTax,
  sOSDetailObj
}) {
  return (
    <div className="Wms-sales-invoice-head">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0, md: 0 }}
        columnSpacing={{ xs: 0.9, sm: 0, md: 0.5 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        sx={{ marginTop: { md: "0px", sm: "0px", xs: "10px" } }}
      >
        <Grid item xs={12} sm={12} md={4.5}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(sErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            
            <Grid item xs={6} sm={4} md={6}>
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxSalesOrderHead.A_VocTyp}
                xOnChange={(e) => {
                  fOnChangeSelectDocType(e);
                }}
                xName={"A_VocTyp"}
                xData={DocLoading}
                xValueMember={""}
                xDispalyMember={""}
                xError={sErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={sErrorMsg.A_VocTyp}
                xDisable={sDetailGridData.length > 0 || vRdxSalesOrderHead.A_VocNo !=0}
                // xOnKeyUp={xKey}
              />
            </Grid>
           
            <Grid item xs={6}  sm={4} md={6}>
              <CmpTextFieldV1
              xLabelText="Doc.No"
               xSize="small"
                xValue={vRdxSalesOrderHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={sErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={sErrorMsg.A_VocNo}
                xOnKeyUp={(e) => {
                  fKeyTabInput(e, "A_PostDt");
                }}
              />
            </Grid>

             
            <Grid item xs={6} sm={4} md={3}>
             <CmpDatePickerField001V1
              xLabelText="Doc.Date"
                xtabIndex={"2"}
                xref={inputReference}
                // xValue={vRdxWmsHead.A_PostDt}
                xValue={vRdxSalesOrderHead.A_PostDt}
                xOnChange={fOnChangeInputDate}
                xName={"A_PostDt"}
                xError={sErrorMsg.A_PostDt === "" ? false : true}
                xErrorMessage={sErrorMsg.A_PostDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_RefDocNo");
                // }}
              />
            </Grid>
            
            <Grid item xs={6} sm={4} md={3}>
             <CmpDatePickerField001V1
              xLabelText="Ref.Date"
                xValue={vRdxSalesOrderHead.A_RefDt}
                xOnChange={(e) => {
                  fOnChangeInputDateRefDate(e);
                }}
                xName={"A_RefDt"}
                xError={sErrorMsg.A_RefDt === "" ? false : true}
                xErrorMessage={sErrorMsg.A_RefDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
              />
            </Grid>
            <Grid item xs={6} sm={4}  md={3}>
              <CmpTextFieldV1
              xLabelText="Ref.No"
               xSize="small"
                xtabIndex={"3"}
                xValue={vRdxSalesOrderHead.A_RefNo}
                xType={"text"} // text/number/password
                xName={"A_RefNo"}
                xReadOnly={false}
                xOnChange={(e) => {
                  fonChangeInput(e);
                }}
                xError={sErrorMsg.A_RefNo === "" ? false : true}
                xErrorMessage={sErrorMsg.A_RefNo}
                // xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={4}  md={3}>
              <CmpCheckboxField
                xChecked={vRdxSalesOrderHead.IsStockReserved === "Y"}
                xOnChange={fonChangeInputIsStockReserved}
                xDisabled={sDetailGridData.length > 0}
                xName={"IsStockReserved"}
                xNameField={"IsStockReserved"}
                xError={sErrorMsg.IsStockReserved === "" ? false : true}
                xErrorMessage={sErrorMsg.IsStockReserved}
              />
            </Grid>
            <Grid item xs={6} sm={4}  md={4}>
                <CmpSelectFieldV1
                  xLabelText="Currency"
                  xValue={vRdxSalesOrderHead.A_Curr}
                  xOnChange={fOnChangeSelectCurr}
                  xName={"A_Curr"}
                  xData={currency}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_Curr === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_Curr}
                  xDisable={sDetailGridData.length > 0}
                  // xDisable={false}
                />
              </Grid>
               
              <Grid item xs={6} sm={4} md={3}>
                <CmpTextFieldV1
              xLabelText="ExRate"
               xSize="small"
                  xValue={vRdxSalesOrderHead.A_ExRate}
                  xType={"number"} // text/number/password
                  xName={"A_ExRate"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                  // xOnKeyUp={(e) => {
                  //   xFocusInput("A_LocName");
                  // }}
                />
              </Grid>
              
              <Grid item xs={6}sm={4} md={3}>
                <CmpSelectArrFieldV1
                  xLabelText="Paymode"
                  xValue={vRdxSalesOrderHead.A_PayMode}
                  xOnChange={(e) => {
                    fonChangeInputPayMode(e);
                  }}
                  xName={"A_PayMode"}
                  xData={sPayModeArr}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_PayMode === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_PayMode}
                  xDisable={false}
                />
              </Grid>
            <Grid item xs={4}  md={2} className=" p-left-label ">
              <span
                className={
                  vRdxSalesOrderHead.A_DocStat === "ENTER"
                    ? "txt-overflow-wms "
                    : "hide-content"
                }
                title={xItemStock?.rpStock}
                onClick={fOpenERPStockModal}
              >
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"ERP: " + xItemStock?.rpStock}
                />{" "}
              </span>
            </Grid>
            {/* <Grid item xs={4} sm={4} md={2}>
              <span
                className={
                  vRdxSalesOrderHead.A_DocStat === "ENTER"
                    ? "txt-overflow-wms"
                    : "hide-content"
                }
                title={xItemStock?.wmsStock}
              >
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"WMS: " + xItemStock?.wmsStock}
                />{" "}
              </span>
            </Grid> */}
            {/* <Grid item xs={4} sm={4} md={2}>
              <span
                className={
                  vRdxSalesOrderHead.A_DocStat === "ENTER"
                    ? "txt-overflow-wms"
                    : "hide-content"
                }
                title={xItemStock?.OpenBinStock}
              >
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"OpenStock: " + xItemStock?.OpenBinStock}
                />{" "}
              </span>
            </Grid> */}
          </Grid>
        </Grid>
        {sToggleGrid ? (
          <Grid item xs={12} sm={12} md={7} lg={7}>
            <Grid
              container
              spacing={0}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className="align-items-start"
            >
              <div style={{ height: 150, width: "100%" }}>
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sGridSalesHistoryRowData}
                  columns={GridDataSalesHistoryColumns}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  // onRowClick={fonRowClickGridObj}
                  hideFooter={sGridSalesHistoryRowData.length < 100}
                />
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={12} sm={12} md={7.5}>
            <Grid
              container
              spacing={0.9}
              columnSpacing={{ xs: 0.9, sm: 0.9, md: 0.2 }}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className={
                hasValueInErrorMessage(sErrorMsg)
                  ? "align-items-center"
                  : "align-items-start"
              }
            >
                
              <Grid item xs={12} sm={12} md={12}>
                <Grid container spacing={0.9}>
                {!vMediaQuery&&  <Grid item xs={3} sm={2} md={2}>
                    <CmpTextFieldV1
              xLabelText="Customer"
               xSize="small"
                      xValue={vRdxSalesOrderHead.A_Party}
                      xType={"text"} // text/number/password
                      xName={"A_Party"}
                      xReadOnly={true}
                      xOnChange={""}
                      xError={sErrorMsg.A_Party === "" ? false : true}
                      xErrorMessage={sErrorMsg.A_Party}
                    />
                  </Grid>}
                  <Grid
                    item
                    xs={12}
                    sm={10}
                    md={10}
                    className="dropDowntoggle"
                  >
                    <GCToggleSearchV1
                       xLabelText="Customer Name"
                      xName={"A_PartyName"}
                      xType={"text"}
                      xValue={vRdxSalesOrderHead.A_PartyName}
                      xReadOnly={false}
                      xOnChange={(e) => {
                        fonChangeInputCustomer(e);
                      }} //GCToggleSearch onchange main input
                      xOnKeyUp={(e) => {
                        fOpenHeadCustomerSearchModalKey(e, "customer");
                      }} //GCToggleSearch xOnKeyUp main input
                      xError={sErrorMsg.A_PartyName === "" ? false : true}
                      xErrorMessage={sErrorMsg.A_PartyName}
                      xMediaQuery={false}
                      xonClickbtn={xhandleClick} // GCToggleSearch onclick icon open div on main screen
                      xrows={xrowDropdownSearch} //GCToggleSearch-grid
                      xcolumns={xcolumnsDropdownSearch} //GCToggleSearch-grid
                      xRowCellClick={xOnCellKeyDown}
                      xRowClick={xOnRowClick}
                      xToggle={xToggleDropdown} //GCToggleSearch- true/false
                      xData={xData} //GCToggleSearch-select
                      xOnChangeDropdownInput={xOnChange} //GCToggleSearch -input
                      xDropdownObj={xDropdownObj} //GCToggleSearch -obj
                      xOnKeyUpDropdownInput={xOnKeyUp} //GCToggleSearch -Enter key and clickc detect
                      xtabIndex="5"
                    />
                  </Grid>
                </Grid>
              </Grid>
          
              <Grid item xs={4}  sm={3} md={2}>
                <CmpTextFieldV1
              xLabelText="Party O/S"
               xSize="small"
                  xValue={sOSDetailObj.partyos < 0 ? "Cr =" : "Dr =" + sOSDetailObj.partyos}
                  xType={"text"} // text/number/password
                  xName={"partyos"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
                />
              </Grid>
              <Grid item xs={4}  sm={3} md={2}>
                <CmpTextFieldV1
              xLabelText="Party PDC"
               xSize="small"
                  xValue={sOSDetailObj.partypdc < 0 ? "Cr =" : "Dr =" + sOSDetailObj.partypdc}

                  xType={"text"} // text/number/password
                  xName={"partypdc"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
                />
              </Grid>
              <Grid item xs={4} sm={3}  md={2}>
                <CmpTextFieldV1
              xLabelText="Cr.Limit"
               xSize="small"
                  xValue={sOSDetailObj.CrLimit}
                  xType={"text"} // text/number/password
                  xName={"CrLimit"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
                />
              </Grid>
              <Grid item xs={6}  sm={3}  md={2}>
                <CmpTextFieldV1
              xLabelText="Party.Net.OS"
               xSize="small"
                  xValue={sOSDetailObj.partyNetOS < 0 ? "Cr =" : "Dr =" + sOSDetailObj.partyNetOS}
                  xType={"text"} // text/number/password
                  xName={"partyNetOS"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
                />
              </Grid>
              <Grid item xs={6}sm={3} md={4}>
                <CmpTextFieldV1
              xLabelText="Cr.Limit.PRD"
               xSize="small"
                  xValue={sOSDetailObj.CrlimitPRD}
                  xType={"text"} // text/number/password
                  xName={"CrlimitPRD"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_LocName");
                // }}
                />
              </Grid>
              
             
            
             
              <Grid item xs={6} sm={3} md={3}>
                <CmpSelectArrFieldV1
                  xLabelText="Type"
                  xValue={vRdxSalesOrderHead?.A_Type}
                  xOnChange={(e) => {
                    fonChangeInput(e);
                  }}
                  xName={"A_Type"}
                  xData={selecType}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_Type === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_Type}
                  xDisable={sDetailGridData.length > 0}
                  xtabIndex={"6"}
                />
              </Grid>
             
              <Grid item xs={6} sm={3} md={3}>
                <CmpSelectFieldV1
                  xLabelText="Location"
                  xValue={vRdxSalesOrderHead.A_Loc}
                  xOnChange={(e) => {
                    fonChangeInputLocation(e);
                  }}
                  xName={"A_Loc"}
                  xData={sLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_Loc === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_Loc}
                  xDisable={sDetailGridData.length > 0}
                />
              </Grid>
            

              
              <Grid item xs={6} sm={3} md={3}>
                <CmpSelectFieldV1
                  xLabelText="Tax Type"
                  xValue={vRdxSalesOrderHead?.A_CUSTFIELD3}
                  xOnChange={(e) => {
                    fonChangeInputTaxType(e);
                  }}
                  xName={"A_CUSTFIELD3"}
                  xData={sTax}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={sErrorMsg.A_CUSTFIELD3 === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_CUSTFIELD3}
                  // xDisable={sDetailGridData.length > 0} client
                  xDisable={true}
                />
              </Grid>

            
              <Grid item xs={2} sm={2} md={1}  >
                <CmpCheckboxField
                  xChecked={vRdxSalesOrderHead.A_Taxable === "Y"}
                  xOnChange={fonChangeInputTaxable}
                  xDisabled={true}
                  xName={"A_Taxable"}
                  xNameField={"Tax"}
                  xError={sErrorMsg.A_Taxable === "" ? false : true}
                  xErrorMessage={sErrorMsg.A_Taxable}
                />
              </Grid>

             

              
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
